module.exports = __webpack_public_path__ + "img/suit.37dd3ce5.png";